import React from 'react';
import styles from './Authentic.module.css';

import asset1 from '../../../assets/authentic-asset1.png';
import asset2 from '../../../assets/authentic-asset-4m.png';
import tallPhoto from '../../../assets/authentic-asset-3m.png'; // Replace with the actual path

const Authentic = () => {
  return (
    <section className={styles.authenticSection}>
      <h1 className={styles.authenticTitle}>AUTHENTIC</h1>

      <div className={styles.content}>
        <div className={styles.imageContainer}>
          <img src={asset1} alt="Asset 1" className={styles.asset1} />
</div>
        <div className={styles.imageContainer}>
          <img src={asset2} alt="Asset 2" className={styles.asset2} />
        </div>

        <div className={styles.profileSection}>
          <h2 className={styles.subtitle}>In depth profiles</h2>
          <img src={tallPhoto} alt="Tall Photo" className={styles.tallPhoto} />
        </div>
      </div>
    </section>
  );
};

export default Authentic;
